export const NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS = {
	HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight1',
} as const;

export const NewContentHistoryOnboardingStateKeys = [
	...Object.values(NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS),
] as const;
